// // import React from "react";
// // import BasicModal from "../../../../Components/Modals/BasicModal";
// // import Btn from "../../../../Components/Buttons/Btn";
// // import { RiDeleteBin5Line } from "react-icons/ri";
// // import useAxios from "../../../../Hooks/useAxios";

// // const DeleteModal = ({
// //   showDeleteModal,
// //   setShowDeleteModal,
// //   selectedScheduleId,
// //   fetchSchedules, // optional: to refresh list after delete
// // }) => {
// //   const request = useAxios();

// //   const handleDelete = async () => {
// //     const res = await request({
// //       method: "DELETE",
// //       url: `scheduling/delete?id=${selectedScheduleId}`,
// //     });

// //     if (res === "error") return;

// //     setShowDeleteModal(false);

// //     if (fetchSchedules) fetchSchedules();
// //   };

// //   if (!showDeleteModal) return null;

// //   return (
// //     <BasicModal
// //       showModal={showDeleteModal}
// //       setShowModal={setShowDeleteModal}
// //       header="Delete Schedule"
// //     >
// //       <div className="m-auto p-5">
// //         <h2 className="text-center text-red text-xl font-bold mb-6">
// //           Are you sure you want to delete this schedule?
// //         </h2>
// //         <div className="flex justify-between items-center">
// //           <Btn
// //             outline={true}
// //             btn="border"
// //             onClick={() => setShowDeleteModal(false)}
// //           >
// //             <p>Cancel</p>
// //           </Btn>
// //           <Btn outline={true} btn="border" onClick={handleDelete}>
// //             <div className="flex justify-between items-center gap-x-2">
// //               <RiDeleteBin5Line className="text-red" />
// //               <p>Confirm</p>
// //             </div>
// //           </Btn>
// //         </div>
// //       </div>
// //     </BasicModal>
// //   );
// // };

// // export default DeleteModal;

// import React from "react";
// import BasicModal from "../../../../Components/Modals/BasicModal";
// import Btn from "../../../../Components/Buttons/Btn";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const DeleteModal = ({
//   showDeleteModal,
//   setShowDeleteModal,
//   handleDelete,
//   selectedScheduleId,
// }) => {
//   if (!showDeleteModal) return null;

//   return (
//     <BasicModal
//       showModal={showDeleteModal}
//       setShowModal={setShowDeleteModal}
//       header="Delete Schedule"
//     >
//       <div className="m-auto p-5">
//         <h2 className="text-center text-red text-xl font-bold mb-6">
//           Are you sure you want to delete this schedule?
//         </h2>
//         <div className="flex justify-between items-center">
//           <Btn
//             outline={true}
//             btn="border"
//             onClick={() => setShowDeleteModal(false)}
//           >
//             <p>Cancel</p>
//           </Btn>
//           <Btn
//             outline={true}
//             btn="border"
//             onClick={() => handleDelete(selectedScheduleId)}
//           >
//             <div className="flex justify-between items-center gap-x-2">
//               <RiDeleteBin5Line className="text-red" />
//               <p>Confirm</p>
//             </div>
//           </Btn>
//         </div>
//       </div>
//     </BasicModal>
//   );
// };

// export default DeleteModal;

import React from "react";
import BasicModal from "../../../../Components/Modals/BasicModal";
import Btn from "../../../../Components/Buttons/Btn";
import { RiDeleteBin5Line } from "react-icons/ri";

const DeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  handleDelete,
  selectedScheduleId,
}) => {
  if (showDeleteModal) {
    return (
      <BasicModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        header="Delete Schedule"
      >
        <div className="m-auto p-5">
          <h2 className="text-center text-red text-xl font-bold mb-6">
            Are you sure you want to delete this schedule?
          </h2>
          <div className="flex justify-between items-center">
            <Btn
              outline={true}
              btn="border"
              onClick={() => setShowDeleteModal(false)}
            >
              <p className="">Cancel</p>
            </Btn>
            <Btn
              outline={true}
              btn="border"
              onClick={() => handleDelete(selectedScheduleId)}
            >
              <div className="flex justify-between items-center gap-x-2">
                <RiDeleteBin5Line className="text-red" />
                <p className="">Confirm</p>
              </div>
            </Btn>
          </div>
        </div>
      </BasicModal>
    );
  }

  return null;
};

export default DeleteModal;
